const ActivityProgressBar = ({ total, current }) => {
  return (
    <div
      style={{
        display: "flex",
        gap: "8px",
      }}
      className="my-2"
    >
      {[...Array(total)].map((_, index) => (
        <div
          key={index}
          style={{
            height: "8px",
            flex: 1,
            borderRadius: "4px",
            backgroundColor: index < current ? "#4CAF50" : "#E0E0E0",
          }}
        />
      ))}
    </div>
  );
};

export default ActivityProgressBar;
